import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import {
  AccountsLayout,
  Layout,
  PrivateLayout,
  LoginLayout,
  AccountLayout,
} from "../layout";
import { AppRoutes } from "../types/enums";
import { CustomLoader } from "../components/ui/CustomLoader";
import { Integration } from "../components/features/Integration";
import { PublicLayout } from "../layout/PublicLayout";

const LoginView = lazy(() => import("../pages/LoginPage"));
const SignupView = lazy(() => import("../pages/SignUpPage"));
const ProductsPage = lazy(() => import("../pages/ProductsPage"));
const ProductPage = lazy(() => import("../pages/ProductPage"));
const RequirementsPage = lazy(() => import("../pages/RequirementsPage"));
const ProfilePage = lazy(() => import("../pages/ProfilePage"));
const CreateCampaignPage = lazy(() => import("../pages/CreateCampaignPage"));
const ReviewsPage = lazy(() => import("../pages/ReviewsPage"));
const AccountPlanPage = lazy(() => import("../pages/AccountPlanPage"));
const PlaybookPage = lazy(() => import("../pages/PlaybookPage"));
const PublicPlaybookPage = lazy(() => import("../pages/PublicPlaybookPage"));
const WelcomePage = lazy(() => import("../pages/WelcomePage"));
const ClientsPage = lazy(() => import("../pages/ClientsPage"));
const PermissionsPage = lazy(() => import("../pages/PermissionsPage"));

export const AppRouter = () => {
  return (
    <Suspense fallback={<CustomLoader height="100vh" />}>
      <Routes>
        <Route element={<LoginLayout />}>
          <Route path={AppRoutes.LOGIN} element={<LoginView />} />
          <Route path={AppRoutes.AUTH} element={<LoginView />} />
          <Route
            path={`${AppRoutes.REGISTRATION}/fd88faf3-569d-4201-8f82-ea058b6ff7b0`}
            element={<SignupView />}
          />
        </Route>

        <Route element={<PrivateLayout />}>
          <Route element={<Layout />}>
            <Route path={AppRoutes.HOME} element={<ProductsPage />} />
            <Route
              path={`${AppRoutes.ACCOUNTS}/:tab/:campaign_id`}
              element={<AccountsLayout />}
            />
            <Route
              path={`${AppRoutes.ACCOUNT}/:campaign_id/:account_id`}
              element={<AccountLayout />}
            />
            <Route
              path={AppRoutes.CAMPAIGNS}
              element={
                <Integration>
                  <ProductsPage />
                </Integration>
              }
            />
            <Route
              path={AppRoutes.CAMPAIGNS_REQUIREMENTS}
              element={<RequirementsPage />}
            />
            <Route path={AppRoutes.CLIENTS} element={<ClientsPage />} />
            <Route
              path={`${AppRoutes.CAMPAIGNS}/:campaign_id`}
              element={<ProductPage />}
            />
            <Route
              path={`/:campaign_id${AppRoutes.ACCOUNT_PLAN}/:account_id`}
              element={<AccountPlanPage />}
            />
            <Route
              path={`/:campaign_id${AppRoutes.PLAYBOOK}/:member_id`}
              element={<PlaybookPage />}
            />

            <Route path={AppRoutes.PROFILE} element={<ProfilePage />} />
            <Route path={AppRoutes.REVIEWS} element={<ReviewsPage />} />
            <Route path={AppRoutes.PERMISSIONS} element={<PermissionsPage />} />
          </Route>
          <Route
            path={AppRoutes.CREATE_CAMPAIGN}
            element={<CreateCampaignPage />}
          />
        </Route>

        <Route element={<PublicLayout />}>
          <Route
            path={`${AppRoutes.PLAYBOOK}/:member_id`}
            element={<PublicPlaybookPage />}
          />
          <Route
            path={`${AppRoutes.PLAYBOOK}/:campaign_id/:member_id`}
            element={<PublicPlaybookPage />}
          />
          <Route
            path={`${AppRoutes.ACCOUNT_PLAN}/:campaign_id/:account_id`}
            element={<AccountPlanPage isPublic={true} />}
          />
          <Route path={AppRoutes.Welcome} element={<WelcomePage />} />
        </Route>

        <Route path="*" element={<Navigate to={AppRoutes.CAMPAIGNS} />} />
      </Routes>
    </Suspense>
  );
};
